import React, { useEffect } from 'react';
import Lottie from 'react-lottie';
import { useHistory } from 'react-router';
import styles from '../index.module.sass';
import dayjs from 'dayjs';
import Button from 'components/button';
import OnBoardingLayout from 'layout/onboarding';
import { useLoginFlowContext } from '../use-login-flow';
import lottieAnimation from 'lottie/on-street-parking-auto-pay-notice.json';
import amplitude from 'service/amplitude';
import { PATH } from 'config';

const OnStreetParkingAutoPayNoticePage = () => {
  const { state } = useLoginFlowContext();
  const history = useHistory();

  useEffect(() => {
    amplitude.onStreetParkingAutoPayNotice_pageview();
  }, []);

  const onEnable = async () => {
    amplitude.onStreetParkingAutoPayNotice_search_onClick();
    history.push(PATH.STREET_PARKING_CITIES);
  };

  const onPass = () => {
    amplitude.onStreetParkingAutoPayNotice_later_onClick();
    history.replace(PATH.MAIN);
  };

  return (
    <OnBoardingLayout className={styles['on-street-parking-auto-pay-notice']}>
      <div className={styles.top}>
        <div className={styles.title}>
          路邊停車自動繳
          <br />
          使用提醒
        </div>
        <div className={styles.desc}>
          因政府規範，啟用日前的繳費單無法自動扣繳，若有停車日期於 {dayjs().format('MM.DD')}{' '}
          前的未繳單，可使用查詢繳費功能，選取停車縣市、車牌即可付款！
        </div>
        <Lottie
          width={window.innerWidth === 320 ? 150 : 200}
          height={window.innerWidth === 320 ? 150 : 200}
          options={{
            autoplay: true,
            loop: true,
            animationData: lottieAnimation,
          }}
        />
      </div>
      <div className={styles.bottom}>
        <Button theme="blue" block={true} loading={state.loading} onClick={onEnable}>
          查詢待繳單付款
        </Button>
        <Button theme="link" block={true} onClick={onPass}>
          略過
        </Button>
      </div>
    </OnBoardingLayout>
  );
};

export default OnStreetParkingAutoPayNoticePage;
